<template>
  <div class="divmain" v-loading="loading">
    <div class="nav_div" v-if="qadata!==null">
      <span class="nav_div_navtext">旅游问答</span> >
      {{qadata.pro_category_title}}旅游问答</div>
    <div class="qa_content" v-if="qadata!==null">
      <div class="search_div">
        <div class="search_div_input">
          <el-input placeholder="提问前请搜索，看看你的问题是否已经问过" v-model="searchinput" clearable></el-input>
        </div>
        <div class="search_div_btn">
          <el-button type="warning" round icon="el-icon-search" style="background: #fbb907;border-color: #fbb907;"></el-button>
          <el-button type="success" round icon="el-icon-edit" class="searchaddbtn">我要提问</el-button>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="qa_question">
        <div class="qa_question_title">问：{{qadata.question_title}}</div>
        <div class="qa_question_detail" v-html="qadata.question_detail"></div>
        <div class="qa_question_ot">{{qadata.question_user_name}} {{qadata.question_user_city}} 发布于
          {{qadata.question_addtime}}</div>
        <div class="qa_question_info">
          {{qadata.question_browse}}浏览&nbsp;&nbsp;{{qadata.question_ans}}回答&nbsp;&nbsp;{{qadata.question_feed}}评论
          &nbsp;<el-button type="success" size="small" plain round>关注</el-button>
          <el-button type="success" size="small" round>回答</el-button>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="qa_aw_div">
        <div class="qa_aw_div_title">{{qadata.question_answer.length}}个回答</div>
        <div class="qa_aw_item" v-for="item in qadata.question_answer" :key="item.question_answer_guid">
          <div class="qa_aw_item-user">
            <div class="user_headpic"><img :src="item.question_answer_user_headpic" /></div>
            <div class="user_info">{{item.question_answer_user_name}}
              <span style="color:#fbb907">LV.{{item.question_answer_user_lv}}</span>
              &nbsp;<el-tag type="danger" v-if="item.question_answer_top">题主采纳</el-tag>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="qa_aw_item-content" v-html="item.question_answer_detail"></div>
          <div class="qa_aw_item-info">{{item.question_answer_pl.length}}条评论 | 收藏 | 发布于
            {{item.question_answer_addtime}}</div>
          <div class="qa_aw_item-pl">
            <div class="qa_aw_item-pl-item" v-for="pl in item.question_answer_pl" :key="pl.question_answer_guid">
              <div class="qa_aw_item-pl-itemuser">
                <div class="user_headpic"><img :src="pl.question_answer_user_headpic" /></div>
                <div class="user_info">{{pl.question_answer_user_name}}
                  <span style="color:#fbb907">LV.{{pl.question_answer_user_lv}}</span>
                </div>
                <div class="user_content" v-html="pl.question_answer_detail"></div>
                <div class="user_ot">{{pl.question_answer_addtime}}</div>
                <div class="clearfix"></div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="qa_ot">
      <el-button type="success" round style="width:100%;margin-top:11px;"><i class="el-icon-edit"></i>&nbsp;&nbsp;我要提问</el-button>
      <el-card class="" style="margin-top:20px;font-size:14px;">
        <div slot="header" class="clearfix">
          <span>中国国旅(宁波)</span>
        </div>
        <p><i class="el-icon-location-outline"></i> 宁波市海曙区开明街396号平安大厦12楼</p>
        <p><i class="el-icon-message"></i> 2851869510@qq.com</p>
        <p><i class="el-icon-phone-outline"></i> 0574-87236749</p>
      </el-card>
      <div class="qa_otherli">
        <el-tabs value="first">
          <el-tab-pane label="其它相关问题" name="first"></el-tab-pane>
        </el-tabs>
        <p><i class="el-icon-chat-round"></i> 台湾有哪些震撼的风景必须推荐？</p>
        <p><i class="el-icon-chat-round"></i> 台湾哪里有湖泊呢？</p>
        <p><i class="el-icon-chat-round"></i> 你觉得台湾是一个怎样的地方？你会首选台湾哪个目的地？</p>
        <p><i class="el-icon-chat-round"></i> 打算7、8月去台湾全境游，路线怎么走合适？大致预算需要多少？</p>
        <p><i class="el-icon-chat-round"></i> 七月末台湾自驾，租普通轿车是否可行？路况如何？</p>
        <p><i class="el-icon-chat-round"></i> 想问下台湾本地人，你们认为台湾最美的草原是哪一个？</p>
        <p><i class="el-icon-chat-round"></i> 看过清境农场还有必要去看日月潭吗</p>
        <p><i class="el-icon-chat-round"></i> 暑假去台湾，7月和8月哪个时间更合适？</p>
        <p><i class="el-icon-chat-round"></i> 台北及周边有哪些好玩的地方？</p>
        <p><i class="el-icon-chat-round"></i> 台湾十天左右，行程怎么安排比较好？</p>
        <p><i class="el-icon-chat-round"></i> 五月份下旬台湾的天山天池，鹅銮鼻，太鲁阁，九份老街景色怎么样啊？</p>
        <p><i class="el-icon-chat-round"></i> 台湾4月底去还冷吗？天池适合老年人去吗？</p>
        <p><i class="el-icon-chat-round"></i> 台湾日月潭几月份的景色最美？飞驰人生取景地在哪？</p>
        <p><i class="el-icon-chat-round"></i> 冬天去日月潭可以吗？只在老城玩，冬天和夏天有区别吗？</p>
        <p><i class="el-icon-chat-round"></i> 除了奶茶，台湾拉面还有哪些菜品非常赞？</p>
        <p><i class="el-icon-chat-round"></i> 台湾有哪些比较经典的自驾游线路？</p>
        <p><i class="el-icon-chat-round"></i> 4月中旬去台湾的台北还是台中好？这个季节哪边的景色更美？</p>
        <p><i class="el-icon-chat-round"></i> 现在台湾安全吗？听说台湾秋天最美，想要去看看，但又怕不安全……</p>
        <p><i class="el-icon-chat-round"></i> 台湾高美湿地什么时候去景色最美？</p>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { getQuestionDetail, questionBadd } from "@/api/ayv3/base";
export default {
  name: "ques_view",
  components: {

  },
  data() {
    return {
      loading: true,
      guid: this.$route.query.d,
      qadata: null,
      searchinput: ''
    }
  },
  methods: {
    //取问答
    getQuestionDetail() {
      var postparam = {
        guid: this.guid
      };
      getQuestionDetail(postparam).then(res => {
        if (res.data.code === 0) {
          this.qadata = res.data.data;
          document.title = this.qadata.question_title + " 中国国旅宁波";
          this.loading = false;
        } else {
          this.$alert(res.data.message, '提示');
        }
      })
    },
    //问答详情浏览增加
    questionBadd() {
      var postparam = {
        guid: this.guid
      };
      questionBadd(postparam).then(res => {
        if (res.data.code === 0) {

        } else {
          this.$alert(res.data.message, '提示');
        }
      })
    },
    hide: function () {
      // 现在我们可以让 Choices 使用这个引用
      // 在从 DOM 中移除这些元素之前进行清理工作
      this.qadata.destroy()
    }
  },
  mounted() {
    this.getQuestionDetail();
    this.questionBadd();
  }
};
</script>
<style lang="less">
.qa_ot {
  float: right;
  width: 350px;
  padding: 0 20px;
  .qa_otherli {
    width: 100%;
    font-size: 14px;
    margin-top: 40px;
    color: #909399;
    p {
      padding: 0 5px;
    }
  }
}

.qa_content {
  float: left;
  width: calc(~"100% - 400px");
  padding: 0 20px;
  .qa_question {
    width: 100%;
    margin-top: 20px;
    .qa_question_title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      line-height: 25px;
      color: #606266;
    }
    .qa_question_detail {
      width: 100%;
      font-size: 16px;
      line-height: 25px;
      color: #606266;
      img {
        max-width: 100%;
      }
    }
    .qa_question_ot {
      width: 100%;
      font-size: 14px;
      color: #909399;
      padding: 10px 0;
    }
    .qa_question_info {
      width: 100%;
      font-size: 14px;
      color: #909399;
      text-align: right;
      border-top: 1px solid #dcdfe6;
      padding: 10px 0;
    }
  }
  .qa_aw_div {
    width: 100%;
    .qa_aw_div_title {
      width: 100%;
      border-bottom: 1px solid #dcdfe6;
      font-size: 14px;
      color: #909399;
      padding: 10px 0;
    }
    .qa_aw_item {
      width: 100%;
      padding: 20px 0;
      .qa_aw_item-user {
        width: 100%;
        .user_headpic {
          float: left;
          width: 50px;
          height: 50px;
          overflow: hidden;
          border-radius: 50%;
          border: 1px solid #dcdfe6;
          img {
            width: 100%;
          }
        }
        .user_info {
          float: left;
          margin-left: 10px;
          font-size: 16px;
          line-height: 50px;
          color: #606266;
        }
      }
      .qa_aw_item-content {
        width: 100%;
        font-size: 16px;
        line-height: 25px;
        color: #606266;
        img {
          max-width: 100%;
        }
      }
      .qa_aw_item-info {
        width: 100%;
        font-size: 14px;
        color: #909399;
        text-align: left;
        border-bottom: 1px solid #dcdfe6;
        padding: 10px 0;
      }
      .qa_aw_item-pl {
        width: 100%;
        margin-top: 10px;
        .qa_aw_item-pl-item {
          width: 100%;
          padding-left: 50px;
          margin-top: 10px;
          .qa_aw_item-pl-itemuser {
            width: 100%;
            .user_headpic {
              float: left;
              width: 50px;
              height: 50px;
              overflow: hidden;
              border-radius: 50%;
              border: 1px solid #dcdfe6;
              img {
                width: 100%;
              }
            }
            .user_info {
              float: left;
              margin-left: 10px;
              font-size: 16px;
              line-height: 50px;
              color: #fa7a11;
            }
            .user_content {
              float: left;
              width: 100%;
              padding-left: 60px;
              font-size: 16px;
              line-height: 25px;
              color: #606266;
              img {
                max-width: 100%;
              }
              p {
                margin: 0;
              }
            }
            .user_ot {
              float: left;
              width: 100%;
              font-size: 14px;
              color: #909399;
              text-align: left;
              border-bottom: 1px solid #dcdfe6;
              padding: 10px 0;
              padding-left: 50px;
            }
          }
        }
        @media screen and (max-width: 1066px) {
          .qa_aw_item-pl-item {
            width: 100%;
            padding-left: 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1066px) {
  .qa_content {
    float: left;
    width: 100%;
    padding: 0 20px;
  }
  .qa_ot {
    display: none;
  }
}
.nav_div {
  width: 100%;
  font-size: 14px;
  color: #909399;
  padding: 5px 20px;
  .nav_div_navtext {
    color: #fbb907;
  }
}
.search_div {
  width: 100%;
  padding: 10px 0;
  .search_div_input {
    float: left;
    width: calc(~"100% - 80px");
    input {
      border-radius: 20px;
    }
    .el-input__inner {
      border: 1px solid #fbb907;
    }
  }
  .search_div_btn {
    width: 70px;
    float: right;
  }
  .searchaddbtn {
    display: none;
  }
}
@media screen and (max-width: 1066px) {
  .search_div {
    .search_div_input {
      width: calc(~"100% - 200px");
    }
    .search_div_btn {
      width: 195px;
      float: right;
    }
    .searchaddbtn {
      display: inline;
    }
  }
}
</style>

